/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import styled from 'styled-components';
import Close from '@mui/icons-material/Close';
import { FilterSelectItem } from './FilterSelect';
import StyledProps from '../theme/AppThemeInterface';
import { abbreviateNetworkName } from '../../../utils/StringUtils';
import { NetworkOrigin } from '../../../shared/entities/terminal';

export interface FilterItemProps {
  filter: FilterSelectItem;
  onClick?: () => any;
}

const FilterItem = (props: FilterItemProps) => {
  const { filter, onClick } = props;
  return (
    <FilterButton data-test={`${filter.parentLabel}_${filter.label}`}>
      <FilterButtonTitle>{filter.parentLabel}:</FilterButtonTitle>{' '}
      {abbreviateNetworkName(filter.label as NetworkOrigin)}
      <Close onClick={onClick} data-test={`${filter.parentLabel}_${filter.label}_close_button`} />
    </FilterButton>
  );
};

export default FilterItem;

const FilterButton = styled.div`
  height: 35px;
  margin-left: 1rem;
  border: 1px solid #141d24;
  border-radius: 26px;
  background-color: #16232c;
  padding: 0px 14px 0px 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  font-size: 13px;
  text-transform: uppercase;

  svg {
    margin-left: 6px;
    color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
    height: 18px;
    width: 18px;

    &:hover {
      cursor: pointer;
    }
  }
`;

const FilterButtonTitle = styled.span`
  color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
  font-family: 'Source Sans Pro';
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  margin-right: 6px;
`;
